"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-handle.tsx
var Handle = function Handle(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00033 3.33341C2.73671 3.33341 3.33366 2.73646 3.33366 2.00008C3.33366 1.2637 2.73671 0.666748 2.00033 0.666748C1.26395 0.666748 0.666992 1.2637 0.666992 2.00008C0.666992 2.73646 1.26395 3.33341 2.00033 3.33341ZM2.00033 7.33341C2.73671 7.33341 3.33366 6.73646 3.33366 6.00008C3.33366 5.2637 2.73671 4.66675 2.00033 4.66675C1.26395 4.66675 0.666992 5.2637 0.666992 6.00008C0.666992 6.73646 1.26395 7.33341 2.00033 7.33341ZM3.33366 10.0001C3.33366 10.7365 2.73671 11.3334 2.00033 11.3334C1.26395 11.3334 0.666992 10.7365 0.666992 10.0001C0.666992 9.2637 1.26395 8.66675 2.00033 8.66675C2.73671 8.66675 3.33366 9.2637 3.33366 10.0001ZM6.00033 3.33341C6.73671 3.33341 7.33366 2.73646 7.33366 2.00008C7.33366 1.2637 6.73671 0.666748 6.00033 0.666748C5.26395 0.666748 4.66699 1.2637 4.66699 2.00008C4.66699 2.73646 5.26395 3.33341 6.00033 3.33341ZM7.33366 6.00008C7.33366 6.73646 6.73671 7.33341 6.00033 7.33341C5.26395 7.33341 4.66699 6.73646 4.66699 6.00008C4.66699 5.2637 5.26395 4.66675 6.00033 4.66675C6.73671 4.66675 7.33366 5.2637 7.33366 6.00008ZM6.00033 11.3334C6.73671 11.3334 7.33366 10.7365 7.33366 10.0001C7.33366 9.2637 6.73671 8.66675 6.00033 8.66675C5.26395 8.66675 4.66699 9.2637 4.66699 10.0001C4.66699 10.7365 5.26395 11.3334 6.00033 11.3334Z"
  }));
};

var _default = Handle;
exports.default = _default;